import { useCallback, useState } from "react";
import ExportDialog, { ExportDialogProps } from "./ExportDialog";
import { Button, ButtonProps } from "../ui/button";
import { useTranslation } from "react-i18next";
import { Module } from "@/constants";
import { DownloadIcon } from "lucide-react";
import type { ExportFeatures } from "@/types/exportFeatures";

interface ExportButtonProps extends ButtonProps, ExportDialogProps {
  moduleName: Module;
  queryParams?: URLSearchParams;
  exportFeatures?: ExportFeatures;
}

export const ExportButton = ({
  moduleName,
  queryParams,
  allowedFormats,
  exportFeatures,
  variant = "ghost",
  children,
  ...props
}: ExportButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const onClick = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <>
      <Button variant={variant} {...props} onClick={onClick}>
        <DownloadIcon className="w-4 h-4 mr-1" />
        {children ?? t("exportDialog.title")}
      </Button>
      <ExportDialog
        open={open}
        onOpenChange={setOpen}
        moduleName={moduleName}
        params={queryParams}
        allowedFormats={allowedFormats}
        exportFeatures={exportFeatures}
      />
    </>
  );
};
